module.exports = vendor_5a1762222b69527363e5;